import React from 'react';
import { capabilities } from '../data/mockData';
import {
  ClipboardList,
  FileSearch,
  Calculator,
  DollarSign,
  PenTool,
  HardHat,
  Users } from
'lucide-react';

const iconMap = [
ClipboardList,
FileSearch,
Calculator,
DollarSign,
PenTool,
HardHat,
Users];


export const CapabilitiesSection = () => {
  return (
    <section id="capabilities" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Project Management Services
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">Comprehensive project management support for government and non-government infrastructure delivery

          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {capabilities.map((capability) => {
            const IconComponent = iconMap[capabilities.indexOf(capability) % iconMap.length];
            return (
              <div
                key={capability.id}
                className="group relative bg-white p-8 rounded-xl border border-slate-200 hover:border-blue-300 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden">

                <div className="relative z-10">
                  {/* Enhanced icon container */}
                  <div className="mb-6 relative">
                    <div className="relative w-16 h-16 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 rounded-2xl flex items-center justify-center transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-xl">
                      <IconComponent className="w-8 h-8 text-white" />
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-blue-900 transition-colors duration-300">
                    {capability.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {capability.description}
                  </p>
                </div>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-blue-900 to-transparent transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
              </div>);

          })}
        </div>
      </div>
    </section>);

};